import React from "react";
import { cn } from "../../utils/twMerge";
import { useLocation } from "react-router-dom";

const Breadcrumbs = ({ items }) => {
  const location = useLocation();
  const url = location.pathname;
  return (
    <div className="[&>ul>li]:before:bt-2 [&>ul>li]:before:br-2 breadcrumbs flex w-full justify-between pb-4 text-sm  [&>ul>li>a]:text-base [&>ul>li]:before:h-[16px] [&>ul>li]:before:w-[16px]">
      <ul className="">
        {items.map((item, idx) => (
          <li
            key={idx}
            className={cn(
              idx === 0 && "before:hidden",
              "text-[1rem] text-[#B6B6B6]",
              idx === items.length - 1 &&
                "text-[1rem] font-bold text-[#1E1E1E] opacity-80",
            )}
          >
            {item}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Breadcrumbs;
